import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrequenciaAluno } from 'src/app/core/frequencia-aluno';
import { Rotas } from 'src/app/core/rotas';
import { FrequenciaAlunoUnidade } from '../../core/frequencia-aluno-unidade';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class FrequenciaAlunoService extends BaseService<FrequenciaAluno> {

  constructor(http: HttpClient) {
    super(http, Rotas.FREQUENCIA_ALUNO);
  }

  alterarAll(frequenciasAluno: FrequenciaAluno[], idAtividade: number, dataReferencia: Date) {
    return this.http.put(`${Rotas.FREQUENCIA_ALUNO}matriculado/atividade/${idAtividade}`, frequenciasAluno, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }

  alterarAllPorUnidade(frequenciasAlunoUnidade: FrequenciaAlunoUnidade[], idUnidade: number, dataReferencia: Date) {
    return this.http.put(`${Rotas.FREQUENCIA_ALUNO}matriculado/unidade/${idUnidade}`, frequenciasAlunoUnidade, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }

  getListaFrequencia(idAtividade: number, dataReferencia: Date) {
    return this.http.get(Rotas.FREQUENCIA_ALUNO + 'frequencia/atividade/' + idAtividade, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }

  getListaFrequenciaUnidade(idUnidade: number, dataReferencia: Date) {
    return this.http.get(Rotas.FREQUENCIA_ALUNO + 'frequencia/unidade/' + idUnidade, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }

  getAlunosMatriculados(idAtividade: number, dataReferencia: Date) {
    return this.http.get(Rotas.FREQUENCIA_ALUNO + 'matriculado/atividade/' + idAtividade, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }

  getListaFrequenciaAlunosUnidade(idInstituicao: number, dataReferencia: Date) {
    return this.http.get(Rotas.FREQUENCIA_ALUNO + 'matriculado/unidade/' + idInstituicao, { params: {
      datafrequencia: `${dataReferencia.getTime()}`   }
    });
  }
}
